module.exports = __webpack_public_path__ + "static/media/hesham.dd12ca36.jpg";